import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import ReactModal from 'react-modal';
import { MarketingHeader, MarketingFooter, MarketingPageSection, MarketingPageWrapper } from 'components/Marketing';
import xhr from 'xhr.js';
import services from 'services/services';
import { Flex, Box, Button, Heading } from 'rebass';
import { Label, Input } from '@rebass/forms';
import config from 'config';
import { FiArrowRight, FiPlayCircle } from 'react-icons/fi';
import NiceWrapper from 'components/NiceWrapper';
import auth from 'services/auth';
import SSAppPanel from 'images/screenshots/app-panel.png';
import SSAppEmail1on1 from 'images/screenshots/app-email-one-on-one.png';
import SSAppScreener from 'images/screenshots/app-screener.png';
import helpers from 'utils/helpers';
const UnderHeadline = styled.div`
    margin: 120px 0 96px 0;
    @media (max-width: 768px) {
        margin: 60px 0 0 0;
    }
`;

const QuotationMarkStart = function() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M13 14.725c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.163 3.742-4.38 5.746 2.491.392 4.396 2.547 4.396 5.149 0 3.182-2.584 4.979-5.199 4.979-3.015 0-5.801-2.305-5.801-6.275zm-13 0c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.163 3.742-4.38 5.746 2.491.392 4.396 2.547 4.396 5.149 0 3.182-2.584 4.979-5.199 4.979-3.015 0-5.801-2.305-5.801-6.275z" />
        </svg>
    );
};
const QuotationMarkEnd = function() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M11 9.275c0 5.141-3.892 10.519-10 11.725l-.984-2.126c2.215-.835 4.163-3.742 4.38-5.746-2.491-.392-4.396-2.547-4.396-5.149 0-3.182 2.584-4.979 5.199-4.979 3.015 0 5.801 2.305 5.801 6.275zm13 0c0 5.141-3.892 10.519-10 11.725l-.984-2.126c2.215-.835 4.163-3.742 4.38-5.746-2.491-.392-4.396-2.547-4.396-5.149 0-3.182 2.584-4.979 5.199-4.979 3.015 0 5.801 2.305 5.801 6.275z" />
        </svg>
    );
};

class HomePage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loadCalendly();
    }

    renderBetaSignup() {
        return (
            <Link to="/signup">
                <Button type="submit" className="huge" mr={0}>
                    Sign Up <FiArrowRight />
                </Button>
            </Link>
        );
    }

    loadCalendly() {
        // Create new script element
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        document.head.appendChild(script);

        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.type = 'text/css';
        css.href = 'https://assets.calendly.com/assets/external/widget.css';
        document.head.appendChild(css);
    }

    render() {
        const company_logos = [
            'endtoenduserresearch.png',
            'theheard.png',
            'UltaResearchServicesLogoWeb.png',
            'amplify-small.jpg',
            'hagen-sinclair.jpg'
        ];

        return (
            <Flex flexDirection="column" style={{ margin: '0px auto', width: '100%' }}>
                <MarketingHeader isMobile={isMobile} auth={this.props.auth} />
                <MarketingPageWrapper isMobile={isMobile}>
                    <Helmet></Helmet>

                    <MarketingPageSection style={{ textAlign: 'center' }}>
                        <Heading
                            as="h1"
                            fontSize={[5, 6, 7]}
                            color="black"
                            style={{ margin: isMobile ? '64px 0 0 0' : '140px 0 0 0' }}
                        >
                            All-in-one software
                            <br />
                            for research recruiting.
                        </Heading>
                        <Box
                            style={{
                                margin: isMobile ? '24px 0 0 0' : '24px 0 32px 0',
                                fontSize: isMobile ? '14px' : '18px'
                            }}
                        >
                            Panel management software, bulk emails, screeners, automated scheduling,{' '}
                            {isMobile ? ' ' : <br />}
                            and more seamlessly level-up your organization.
                        </Box>
                        {isMobile ? <br /> : ''}
                        {helpers.renderDemoSignup()}
                        {isMobile ? (
                            <>
                                <br />
                                <br />
                            </>
                        ) : (
                            ''
                        )}

                        <Button
                            type="button"
                            variant="secondary"
                            className="huge"
                            mx={2}
                            onClick={() => {
                                Calendly.initPopupWidget({ url: 'https://calendly.com/panelfox/welcome' });
                                return false;
                            }}
                        >
                            Talk to Sales
                        </Button>
                        <Box sx={{ fontSize: '12px', color: '#999', marginTop: '56px', marginBottom: '8px' }}>
                            TRUSTED BY
                        </Box>
                        <Flex
                            flexWrap="wrap"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                maxWidth: '880px',
                                margin: '0 auto'
                            }}
                        >
                            {company_logos.map(logo => {
                                return (
                                    <Box px={[0, 2, 4]} py={2} px={'24px'} sx={{ textAlign: 'center' }}>
                                        <img
                                            src={`https://panelfox-images-prod.s3.us-east-2.amazonaws.com/homepage-logos/${logo}`}
                                            style={{
                                                maxWidth: '120px',
                                                maxHeight: '32px',
                                                verticalAlign: 'middle',
                                                filter: 'grayscale(1)'
                                            }}
                                        />
                                    </Box>
                                );
                            })}
                        </Flex>
                    </MarketingPageSection>

                    <UnderHeadline />
                </MarketingPageWrapper>
                <MarketingPageWrapper isMobile={isMobile} fullwidth background="#f9f5f1">
                    <MarketingPageSection style={{ textAlign: 'center' }}>
                        <Box style={{ position: 'relative' }}>
                            <NiceWrapper
                                padding="0"
                                style={{ display: 'inline-block', marginTop: isMobile ? '32px' : '-120px' }}
                            >
                                <img
                                    src={SSAppEmail1on1}
                                    style={{ width: isMobile ? '100%' : '800px' }}
                                    alt="Email one on one"
                                />
                            </NiceWrapper>

                            {!isMobile && (
                                <>
                                    <NiceWrapper
                                        padding="0"
                                        style={{ position: 'absolute', top: '-72px', left: 0, zIndex: -1 }}
                                    >
                                        <img
                                            src={SSAppPanel}
                                            style={{ width: isMobile ? '100%' : '600px' }}
                                            alt="Panel"
                                        />
                                    </NiceWrapper>

                                    <NiceWrapper
                                        padding="0"
                                        style={{ position: 'absolute', top: '-72px', right: 0, zIndex: -1 }}
                                    >
                                        <img
                                            src={SSAppScreener}
                                            style={{ width: isMobile ? '100%' : '600px' }}
                                            alt="Screener"
                                        />
                                    </NiceWrapper>
                                </>
                            )}
                        </Box>
                        <br />
                        <br />
                        <Heading fontSize={[5]} color="black">
                            The panel management software{isMobile ? ' ' : <br />}
                            your whole team will love.
                        </Heading>
                        <Box mt={3} mb={4}>
                            Scale your user research recruiting and increase{isMobile ? ' ' : <br />}
                            the ROI for your entire organization with{isMobile ? ' ' : <br />}
                            integrations and tools built specifically for{isMobile ? ' ' : <br />}
                            you and your team.
                            <br />
                            <br />
                            <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                                <Button type="button" variant="secondary">
                                    Learn more
                                </Button>
                            </Link>
                            <br />
                            <br />
                        </Box>
                    </MarketingPageSection>
                </MarketingPageWrapper>

                {/*<MarketingPageWrapper isMobile={isMobile}>
                    <MarketingPageSection style={{ textAlign: 'center', margin: '32px 0' }}>
                        test
                    </MarketingPageSection>
                </MarketingPageWrapper>*/}
                <MarketingPageWrapper isMobile={isMobile}>
                    <MarketingPageSection style={{ textAlign: 'center', margin: '32px 0' }}>
                        <Heading fontSize={[5]} color="black" mt={5}>
                            Driven by outcomes
                            <br />
                        </Heading>
                        <Box mt={3} mb={4}>
                            Fast user research recruiting, great customer service, and happy customers.
                            <br />
                            <br />
                        </Box>

                        <NiceWrapper
                            style={{ maxWidth: '900px', padding: '48px', textAlign: 'left', background: '#fff' }}
                        >
                            <Heading fontSize={[4]} color="black" mb={3}>
                                Panelfox is a game-changer.
                            </Heading>
                            <Box fontSize={1}>
                                <span style={{ color: '#ddd', marginRight: '8px' }}>
                                    <QuotationMarkStart />
                                </span>
                                It's very intuitive, easy to set up, and everything is in one place. So far, there is
                                nothing that this platform has failed to accomplish. <br />
                                <br />
                                For project managers, we know how cumbersome preparing a study can be, and Panelfox has
                                cut my setup time in half. It improves productivity by filtering out all those
                                unqualified people, and increases show rates using the auto-reminders. Customer Support
                                - this is where the rubber meets the road. The team at Panelfox provides excellent
                                customer support, and they listen to your needs. Thank you for developing this cool
                                customer-driven tool, for delivering fantastic service, and for just being generally
                                awesome! Panelfox is a game-changer.
                                <span style={{ color: '#ddd', marginLeft: '8px' }}>
                                    <QuotationMarkEnd />
                                </span>
                                <Flex mt={4} sx={{ gridGap: 3 }}>
                                    <Box>
                                        <img
                                            src="gary-reynolds.jpg"
                                            style={{ height: '64px', borderRadius: '50%' }}
                                            alt="Graphic"
                                        />
                                    </Box>
                                    <Box>
                                        <Heading
                                            fontSize={[2]}
                                            className="black"
                                            style={{ fontWeight: 400, marginTop: '12px' }}
                                        >
                                            Gary Reynolds
                                        </Heading>
                                        <Box fontSize={1}>Hagen/Sinclair Research Recruiting Inc</Box>
                                    </Box>
                                </Flex>
                            </Box>
                        </NiceWrapper>
                        <br />
                        <br />
                        <br />
                    </MarketingPageSection>
                </MarketingPageWrapper>

                <MarketingPageWrapper isMobile={isMobile} fullwidth background="#f9f5f1">
                    <MarketingPageSection style={{ textAlign: 'left', margin: '64px 0' }}>
                        <Flex flexWrap="wrap" style={{ alignItems: 'center' }}>
                            <Box width={[1, 1 / 2]} px={[0, 4]}>
                                <img
                                    src="https://panelfox-images-prod.s3.us-east-2.amazonaws.com/homepage-logos/319903c5-b4f5-47a4-b87c-a753a0091834.png"
                                    style={{ width: '100%' }}
                                    alt="Graphic"
                                />
                            </Box>
                            <Box width={[1, 1 / 2]} px={[0, 4]}>
                                {isMobile ? <br /> : ''}
                                <Box fontSize={1} mb={2}>
                                    PANEL MANAGEMENT
                                </Box>
                                <Heading fontSize={[5]} color="black">
                                    Find the right people
                                </Heading>
                                <br />
                                Build and manage user profiles to better understand your panelists. Collect answers in
                                surveys, update details from your database, and track participation all in one location.
                                <br />
                                <br />
                                <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                                    <Button type="button" variant="secondary">
                                        Learn more
                                    </Button>
                                </Link>
                            </Box>
                        </Flex>
                    </MarketingPageSection>
                </MarketingPageWrapper>
                <MarketingPageWrapper isMobile={isMobile}>
                    <MarketingPageSection style={{ textAlign: 'left', margin: '64px 0' }}>
                        <Flex flexWrap="wrap" style={{ alignItems: 'center' }}>
                            <Box width={[1, 1 / 2]} px={[0, 4]} order={[2, 1]}>
                                {isMobile ? <br /> : ''}
                                <Box fontSize={1} mb={2}>
                                    BULK EMAIL & 1:1 EMAIL
                                </Box>
                                <Heading fontSize={[5]} color="black">
                                    Ensure a human connection
                                </Heading>
                                <br />
                                Respondents are humans, not currency. Panelfox makes it easy to personalize and automate
                                recruitment emails at scale or 1:1. Treat your panelists with respect and never miss a
                                response or question.
                                <br />
                                <br />
                                <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                                    <Button type="button" variant="secondary">
                                        Learn more
                                    </Button>
                                </Link>
                            </Box>
                            <Box width={[1, 1 / 2]} px={[0, 4]} order={[1, 2]}>
                                <img
                                    src="https://panelfox-images-prod.s3.us-east-2.amazonaws.com/homepage-logos/b46bba81-a811-4312-aded-7d136443f04a.png"
                                    style={{ width: '100%' }}
                                    alt="Graphic"
                                />
                            </Box>
                        </Flex>
                    </MarketingPageSection>
                </MarketingPageWrapper>
                <MarketingPageWrapper isMobile={isMobile} fullwidth background="#f9f5f1">
                    <MarketingPageSection style={{ textAlign: 'left', margin: '64px 0' }}>
                        <Flex flexWrap="wrap" style={{ alignItems: 'center' }}>
                            <Box width={[1, 1 / 2]} px={[0, 4]}>
                                <img
                                    src="https://panelfox-images-prod.s3.us-east-2.amazonaws.com/homepage-logos/255f6e5a-eedd-4f0e-81d3-7667ef72314b.png"
                                    style={{ width: '100%' }}
                                    alt="Graphic"
                                />
                            </Box>
                            <Box width={[1, 1 / 2]} px={[0, 4]}>
                                {isMobile ? <br /> : ''}
                                <Box fontSize={1} mb={2}>
                                    PROJECT MANAGEMENT
                                </Box>
                                <Heading fontSize={[5]} color="black">
                                    Always know what{"'"}s happening
                                </Heading>
                                <br />
                                With Panelfox you can track communication with panelists, see study statuses and see the
                                speed with which your team works! Gain momentum and make recruitment a breeze.
                                <br />
                                <br />
                                <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                                    <Button type="button" variant="secondary">
                                        Learn more
                                    </Button>
                                </Link>
                            </Box>
                        </Flex>
                    </MarketingPageSection>
                </MarketingPageWrapper>
                <MarketingPageWrapper isMobile={isMobile}>
                    <MarketingPageSection style={{ textAlign: 'left', margin: '64px 0' }}>
                        <Flex flexWrap="wrap" style={{ alignItems: 'center' }}>
                            <Box width={[1, 1 / 2]} px={[0, 4]} order={[2, 1]}>
                                {isMobile ? <br /> : ''}
                                <Box fontSize={1} mb={2}>
                                    AUTOMATION
                                </Box>
                                <Heading fontSize={[5]} color="black">
                                    Fast research recruiting
                                </Heading>
                                <br />
                                With automations in Panelfox say goodbye to manual entry and headaches. Create
                                personalized processes, branded communications, and integrate with your existing tools
                                to fill studies while you sleep!
                                <br />
                                <br />
                                <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
                                    <Button type="button" variant="secondary">
                                        Learn more
                                    </Button>
                                </Link>
                            </Box>
                            <Box width={[1, 1 / 2]} px={[0, 4]} order={[1, 2]}>
                                <img
                                    src="https://panelfox-images-prod.s3.us-east-2.amazonaws.com/homepage-logos/3bb3df76-5729-4964-a09e-7852df17c6f7.png"
                                    style={{ width: '100%' }}
                                    alt="Graphic"
                                />
                            </Box>
                        </Flex>
                    </MarketingPageSection>
                </MarketingPageWrapper>
                <MarketingPageWrapper isMobile={isMobile} fullwidth background="#f9f5f1">
                    <MarketingPageSection style={{ textAlign: 'center', margin: '32px 0' }}>
                        {isMobile ? '' : <br />}
                        {isMobile ? '' : <br />}
                        {isMobile ? '' : <br />}
                        {isMobile ? '' : <br />}
                        <br />
                        <Heading fontSize={[5]} color="black">
                            Panelfox has you covered.
                        </Heading>
                        <br />
                        Stop worrying about keeping track of dozens of email threads,{isMobile ? ' ' : <br />}
                        tracking participant attendance, and updating everything manually.
                        <br />
                        <br />
                        {helpers.renderDemoSignup()}
                        <br />
                        {isMobile ? '' : <br />}
                        {isMobile ? '' : <br />}
                        {isMobile ? '' : <br />}
                    </MarketingPageSection>
                </MarketingPageWrapper>
                <MarketingPageWrapper isMobile={isMobile} fullwidth background="#f9f5f1">
                    <MarketingPageSection style={{ textAlign: 'center' }}>
                        <MarketingFooter props={this.props} />
                    </MarketingPageSection>
                </MarketingPageWrapper>
            </Flex>
        );
    }
}

export default HomePage;
